/* ==========================================================================
   Clara & Luce — promo layer
   1) Cuenta atrás de la campaña (.cl-cd[data-end]) con fecha real: se oculta al acabar.
   2) Hora límite del pedido de hoy ([data-cl-midnight]).
   3) Sugerencias en el carrito (.cl-up), pedidas a /recommendations/products.
   Sin MutationObserver (causó bloqueos en Velenne): un solo intervalo de 1 s
   y los eventos pub/sub de Dawn para saber cuándo se ha redibujado el carrito.
   ========================================================================== */
(function () {
  'use strict';

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var setText = function (root, sel, val) {
    var el = root.querySelector(sel);
    if (el && el.textContent !== String(val)) el.textContent = val;
  };

  /* ---------- 1 y 2: contadores ---------- */
  function tick() {
    var now = Date.now();

    var cds = document.querySelectorAll('.cl-cd[data-end]');
    for (var i = 0; i < cds.length; i++) {
      var el = cds[i];
      var end = Date.parse(el.getAttribute('data-end'));
      var ms = end - now;
      if (isNaN(end) || ms <= 0) {
        if (!el.hidden) el.hidden = true;
        continue;
      }
      var s = Math.floor(ms / 1000);
      setText(el, '[data-d]', Math.floor(s / 86400));
      setText(el, '[data-h]', pad(Math.floor((s % 86400) / 3600)));
      setText(el, '[data-m]', pad(Math.floor((s % 3600) / 60)));
      setText(el, '[data-s]', pad(s % 60));
      if (el.hidden) el.hidden = false;
    }

    var mids = document.querySelectorAll('[data-cl-midnight]');
    if (mids.length) {
      var t = new Date();
      var mid = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
      var r = Math.floor((mid - t) / 1000);
      var txt = pad(Math.floor(r / 3600)) + 'h ' + pad(Math.floor((r % 3600) / 60)) + 'm ' + pad(r % 60) + 's';
      for (var j = 0; j < mids.length; j++) {
        if (mids[j].textContent !== txt) mids[j].textContent = txt;
      }
    }
  }

  /* ---------- 3: sugerencias en el carrito ---------- */
  var cache = {};

  function renderUpsell(box, html) {
    var list = new DOMParser().parseFromString(html, 'text/html').querySelector('.cl-up__list');
    if (!list) return;
    var inCart = (box.getAttribute('data-incart') || '').split(',');
    var cards = list.querySelectorAll('.cl-up__card');
    var kept = 0;
    for (var i = 0; i < cards.length; i++) {
      if (inCart.indexOf(cards[i].getAttribute('data-pid')) > -1 || kept >= 6) cards[i].remove();
      else kept++;
    }
    if (!kept) return;
    var body = box.querySelector('.cl-up__body');
    body.innerHTML = '';
    body.appendChild(list);
    box.classList.add('is-ready');
  }

  function fillUpsell() {
    var boxes = document.querySelectorAll('.cl-up[data-pid]:not([data-loaded])');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        box.setAttribute('data-loaded', '1');
        var pid = box.getAttribute('data-pid');
        if (cache[pid]) return renderUpsell(box, cache[pid]);
        var url = (box.getAttribute('data-url') || '/recommendations/products') +
          '?product_id=' + pid + '&limit=10&section_id=cl-cart-upsell&intent=related';
        fetch(url)
          .then(function (res) { return res.ok ? res.text() : ''; })
          .then(function (html) { if (!html) return; cache[pid] = html; renderUpsell(box, html); })
          .catch(function () {});
      })(boxes[i]);
    }
  }

  function addFromUpsell(btn) {
    var card = btn.closest('.cl-up__card');
    var sel = card && card.querySelector('.cl-up__sel');
    var id = sel && sel.value;
    if (!id) {
      if (sel) { sel.classList.add('is-error'); sel.focus(); }
      return;
    }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          setTimeout(fillUpsell, 50);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        var msg = card.querySelector('.cl-up__err') || document.createElement('small');
        msg.className = 'cl-up__err';
        msg.textContent = (err && err.message) || 'Ha habido un error, inténtalo de nuevo.';
        card.querySelector('.cl-up__info').appendChild(msg);
      });
  }

  /* ---------- 4: miniaturas de color en el selector de variantes ---------- */
  function decorateSwatches() {
    var datas = document.querySelectorAll('.cl-sw-data');
    for (var i = 0; i < datas.length; i++) {
      var map;
      try { map = JSON.parse(datas[i].textContent); } catch (e) { continue; }
      var root = datas[i].closest('section') || document;
      var sets = root.querySelectorAll('variant-selects fieldset');
      for (var j = 0; j < sets.length; j++) {
        var legend = sets[j].querySelector('legend');
        if (!legend || !/colore/i.test(legend.textContent)) continue;
        sets[j].classList.add('cl-sw-set');
        // nombre del color elegido en la leyenda ("Colore: Nero"), como Varel
        var checked = sets[j].querySelector('input[type="radio"]:checked');
        var sel = legend.querySelector('.cl-sw-sel');
        if (!sel) { sel = document.createElement('span'); sel.className = 'cl-sw-sel'; legend.appendChild(sel); }
        var selText = checked ? ': ' + checked.value : '';
        if (sel.textContent !== selText) sel.textContent = selText;
        var inputs = sets[j].querySelectorAll('input[type="radio"]');
        for (var k = 0; k < inputs.length; k++) {
          var url = map[inputs[k].value];
          var label = sets[j].querySelector('label[for="' + inputs[k].id + '"]');
          if (!url || !label || label.classList.contains('cl-sw')) continue;
          label.classList.add('cl-sw');
          label.style.setProperty('--cl-sw', 'url("' + url + '")');
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cl-up__add');
    if (btn) { e.preventDefault(); addFromUpsell(btn); }
  });
  /* ---------- 5: cambiar color/talla dentro del carrito (Leonie / Kaching Cart) ---------- */
  function changeVariant(sel) {
    var key = sel.getAttribute('data-key');
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var newId = Number(sel.value);
    var line = sel.closest('.cart-item');
    var routes = window.routes || {};
    var post = function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    };
    sel.disabled = true;
    if (line) line.classList.add('cl-cv--loading');
    // 1) añade la variante nueva; 2) quita la línea antigua y pide el carrito redibujado
    post((routes.cart_add_url || '/cart/add') + '.js', { items: [{ id: newId, quantity: qty }] })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return post((routes.cart_change_url || '/cart/change') + '.js', {
          id: key, quantity: 0, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname
        });
      })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          setTimeout(fillUpsell, 50);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        sel.disabled = false;
        if (line) line.classList.remove('cl-cv--loading');
        var msg = (err && err.message) || 'Variante no disponible';
        var box = line && line.querySelector('.cart-item__error-text');
        if (box) box.textContent = msg; else window.alert(msg);
      });
  }

  /* ---------- 6: envío prioritario opcional (casilla sin marcar por defecto) ---------- */
  function togglePriority(cb) {
    var id = Number(cb.getAttribute('data-variant'));
    var routes = window.routes || {};
    var wrap = cb.closest('.cl-prio');
    var want = cb.checked;
    var body = want
      ? { items: [{ id: id, quantity: 1 }] }
      : { id: String(id), quantity: 0 };
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = window.location.pathname;
    cb.disabled = true;
    if (wrap) wrap.classList.add('is-loading');
    fetch((want ? (routes.cart_add_url || '/cart/add') : (routes.cart_change_url || '/cart/change')) + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          setTimeout(fillUpsell, 50);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        cb.checked = !want;
        cb.disabled = false;
        if (wrap) wrap.classList.remove('is-loading');
      });
  }

  // Fase de captura: nuestros <select> viven dentro de <cart-drawer-items>, que trata cualquier "change"
  // como un cambio de cantidad (cart.js → validateQuantity). Paramos el evento antes de que llegue a Dawn.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('cl-prio__cb')) { e.stopPropagation(); togglePriority(t); return; }
    if (t.classList.contains('cl-cv__sel')) { e.stopPropagation(); changeVariant(t); }
    else if (t.classList.contains('cl-up__sel')) { e.stopPropagation(); t.classList.remove('is-error'); }
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.cl-sw-set')) decorateSwatches();
  });

  function start() {
    tick();
    setInterval(tick, 1000);
    decorateSwatches();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Dawn redibuja el selector al cambiar de variante: volvemos a poner las miniaturas
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(decorateSwatches, 30); });
      if (PUB_SUB_EVENTS.optionValueSelectionChange) {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () { setTimeout(decorateSwatches, 400); });
      }
      // Dawn publica cartUpdate antes de redibujar el carrito: reintento con retardo (idempotente)
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(fillUpsell, 400);
        setTimeout(fillUpsell, 1500);
      });
    }
    // Abrir el carrito desde el icono: el contenido ya está en la página, solo falta rellenar
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble')) setTimeout(fillUpsell, 100);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
